module.exports = __webpack_public_path__ + "img/sw-b01.c8b5d65f.png";